
/**
 * Statische Utility-Klasse zum Thema Cookies
 * @example
 * docCookies.setItem("test0", "Hello world!");
 * docCookies.setItem("test1", "Unicode test: \u00E0\u00E8\u00EC\u00F2\u00F9", Infinity);
 * docCookies.setItem("test2", "Hello world!", new Date(2020, 5, 12));
 * docCookies.setItem("test3", "Hello world!", new Date(2027, 2, 3), "/blog");
 * docCookies.setItem("test4", "Hello world!", "Wed, 19 Feb 2127 01:04:55 GMT");
 * docCookies.setItem("test5", "Hello world!", "Fri, 20 Aug 88354 14:07:15 GMT", "/home");
 * docCookies.setItem("test6", "Hello world!", 150);
 * docCookies.setItem("test7", "Hello world!", 245, "/content");
 * docCookies.setItem("test8", "Hello world!", null, null, "example.com");
 * docCookies.setItem("test9", "Hello world!", null, null, null, true);
 * docCookies.setItem("test1;=", "Safe character test;=", Infinity);
 * alert(docCookies.keys().join("\n"));
 * alert(docCookies.getItem("test1"));
 * alert(docCookies.getItem("test5"));
 * docCookies.removeItem("test1");
 * docCookies.removeItem("test5", "/home");
 * alert(docCookies.getItem("test1"));
 * alert(docCookies.getItem("test5"));
 * alert(docCookies.getItem("unexistingCookie"));
 * alert(docCookies.getItem());
 * alert(docCookies.getItem("test1;="));
 */
export default class Cookies {

    /**
     * gibt das Cookie mit Namen sKey zurück
     */
    static getItem(sKey) {
        return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
    }

    /**
     * Setzt ein Cookie
     * @param {string} name The name of the cookie to create/overwrite (string).
     * @param {string} value The value of the cookie (string).
     * @param {number|Date|string} end Optional The max-age in seconds (e.g. 31536e3 for a year, Infinity for a never-expires cookie), or the expires date in GMTString format or as Date object; if not, the specified the cookie will expire at the end of the session (number – finite or Infinity – string, Date object or null).
     * @param {string} path Optional The path from where the cookie will be readable. E.g., "/", "/mydir"; if not specified, defaults to the current path of the current document location (string or null). The path must be absolute (see RFC 2965). For more information on how to use relative paths in this argument, see this paragraph.
     * @param {string} domain Optional The domain from where the cookie will be readable. E.g., "example.com", ".example.com" (includes all subdomains) or "subdomain.example.com"; if not specified, defaults to the host portion of the current document location (string or null).
     * @param {boolean} secure Optional The cookie will be transmitted only over secure protocol as https (boolean or null).
     */
    static setItem(sKey, sValue, vEnd=null, sPath=null, sDomain=null, bSecure=null) {
        if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) {
            return false;
        }
        let sExpires = "";
        if (vEnd) {
            switch (vEnd.constructor) {
                case Number:
                    sExpires = vEnd === Infinity ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : "; max-age=" + vEnd;
                    break;
                case String:
                    sExpires = "; expires=" + vEnd;
                    break;
                case Date:
                    sExpires = "; expires=" + vEnd.toUTCString();
                    break;
            }
        }
        document.cookie = encodeURIComponent(sKey) + "=" + encodeURIComponent(sValue) + sExpires + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "") + (bSecure ? "; secure" : "");
        return true;
    }

    /**
     * Entfernt ein Cookie. Note: To delete cookies that span over subdomains, you need to explicitate the domain attribute in removeItem() as well as setItem().
     * @param {string} name The name of the cookie to remove (string).
     * @param {string} path Optional E.g., "/", "/mydir"; if not specified, defaults to the current path of the current document location (string or null). The path must be absolute (see RFC 2965). For more information on how to use relative paths in this argument, see this paragraph.
     * @param {string} domain Optional E.g., "example.com",  or "subdomain.example.com"; if not specified, defaults to the host portion of the current document location (string or null), but not including subdomains. Contrary to earlier specifications, leading dots in domain names are ignored. If a domain is specified, subdomains are always included.
     */
    static removeItem(sKey, sPath=null, sDomain=null) {
        if (!sKey || !Cookies.hasItem(sKey)) {
            return false;
        }
        document.cookie = encodeURIComponent(sKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" + ( sDomain ? "; domain=" + sDomain : "") + ( sPath ? "; path=" + sPath : "");
        return true;
    }

    /**
     * prüft, ob ein Cookie existiert
     */
    static hasItem(sKey) {
        return (new RegExp("(?:^|;\\s*)" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=")).test(document.cookie);
    }

    /**
     * gibt alle Cookies zurück
     */
    static keys() {
        const aKeys = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, "").split(/\s*(?:\=[^;]*)?;\s*/);
        for (let i = 0; i < aKeys.length; i++) {
            aKeys[i] = decodeURIComponent(aKeys[i]);
        }
        return aKeys;
    }

}